<template>
    <div class="order_pos" :class="classPos">
        <div class="order_pos_wrapper">
            <div class="order_pos_container">
                <spinner
                    v-if="isOrder && isLoadLogs"
                    :key="'spinner_order_pos_container'"
                />
                <div v-if="isOrder && !isLoadLogs" class="order_pos__title">
                    <div class="order_pos__title_text">
                        POS
                    </div>
                    <button class="order_pos__title_state send_manual" @click.prevent="sendManual">
                        <div class="order_pos__title_state_text">
                            {{ __t('O.SEND_MANUAL') }}
                        </div>
                    </button>
                    <div class="order_pos__title_state">
                        <div class="order_pos__title_state_text">
                            {{ statusText }}
                        </div>
                    </div>
                </div>
                <div v-if="isOrder && !isLoadLogs" class="order_pos__status">
                    <div class="order_pos__status_container">
                        <order_pos_item
                            v-for="item in activeOrderLogs"
                            :key="'order_pos_item_' + item.id"
                            :item="item"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <modal
        v-if="statusModalSendManual"
        :key="'modal_send_manual_pos_' + activeOrderId"
    >
        <template v-slot:content>
            <modal_send_manual_pos
                :key="'modal_send_manual_pos' + activeOrderId"
                @close_modal_send_manual_pos="closeModalSendManualPos"
            />
        </template>
    </modal>

</template>

<script>

import order_pos_item from "./OrderPosItem.vue";
import {createHelpers} from "vuex-map-fields";
import spinner from "../../loader/Spinner.vue";
import modal_send_manual_pos from "../../modal/pos/ModalSendManualPos.vue";
import modal_new_order from "../../modal/new/ModalNewOrder.vue";
import modal from "../../modal/Modal.vue";

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "order_pos",
    props: {
        isLoadLogs: {
            type: Boolean,
            required: true,
        },
        isOrder: {
            type: Boolean,
            required: true,
        },
    },
    emits: [],
    components: {modal, modal_new_order, spinner, order_pos_item, modal_send_manual_pos},
    mixins: [],
    data() {
        return {
            statusModalSendManual: false,
            statusModalTime: false,
            arrayTime: [{time: 2, isSelect: false}],
            actionButton: null,
        }
    },
    methods: {
        sendManual() {
            this.statusModalSendManual = true;
        },
        closeModalSendManualPos() {
            this.statusModalSendManual = false;
        }
    },
    computed: {
        ...mOrders([
            'activeOrderFullInfo',
            'activeOrderLogs',
            'activeOrderPosState',
        ]),
        classPos() {
            if (this.isErrorPos) {
                return {'error': true};
            }
            return {'error': false};
        },
        isErrorPos() {

        },
        statusText() {
            if (this.activeOrderPosState && this.activeOrderPosState.order && this.activeOrderPosState.order.status) {
                return this.activeOrderPosState.order.status;
            }
            return 'No status';
        },
        activeOrderId() {
            if (this.activeOrderPosState && this.activeOrderFullInfo && this.activeOrderFullInfo.id) {
                return this.activeOrderFullInfo.id;
            }
            return '';
        },
    },
}
</script>
